import { SchemaType } from '../type';
export const schema = {
    id: 'ai-page',
    name: get => `AI页面（${get('name')}）`,
    type: SchemaType.Indivisible,
    fieldUncheckable: true,
};
